import { render, staticRenderFns } from "./TransactionInfo.vue?vue&type=template&id=5df5a813&scoped=true&"
import script from "./TransactionInfo.vue?vue&type=script&lang=js&"
export * from "./TransactionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5a813",
  null
  
)

export default component.exports